import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@hortis/ui/hover-card";
import { A, pipe } from "@mobily/ts-belt";
import { type Classification } from "generated/graphql";
import { type ReactNode } from "react";
import {
  RecordField,
  RecordFieldLabel,
  RecordFieldValue,
} from "src/features/records/components/record-field/new-record-field";
import { classificationRankOrder } from "src/features/taxonomy/components/taxon-page/classification";

export const AllRanksHoverCard = ({
  classification,
  children,
}: {
  classification: Classification;
  children: ReactNode;
}) => {
  const orderedClassification = pipe(
    classificationRankOrder,
    A.filter((name) => classification[name] != null),
    A.map((name) => ({ name: classification[name], rank: name })),
  );

  return (
    <HoverCard openDelay={300}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className="flex max-w-xs cursor-default flex-col gap-3 p-4"
        align="start"
      >
        {orderedClassification.map(({ name, rank }) => (
          <RecordField key={rank} className="gap-0.5">
            <RecordFieldLabel className="h-auto">
              {rank.charAt(0).toUpperCase() + rank.slice(1)}
            </RecordFieldLabel>
            <RecordFieldValue className="font-medium text-grey-900">
              {name}
            </RecordFieldValue>
          </RecordField>
        ))}
      </HoverCardContent>
    </HoverCard>
  );
};
